import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, Box, Modal,Backdrop, CircularProgress,LinearProgress, TextareaAutosize } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../../api/DnerhsApi";
import FormInput from "../../../Controls/Input";
import Alert from "../../../components/Alert";
import ResponseUtils from "../../../utils/ResponseUtils";
import history from "../../../utils/History";
import { useParams, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/Auth";
import Tooltip from "@material-ui/core/Tooltip";
import { findById } from "../../../constants/Meses";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Checkbox from '@material-ui/core/Checkbox';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from '@material-ui/icons/Clear';
import GetAppIcon from "@material-ui/icons/GetApp";
import { trackPromise} from 'react-promise-tracker';
import * as XLSX from "xlsx";
import Roles from "../../../constants/Roles";
import EstadosCronograma from "../../../constants/EstadosCronograma";
import ConfirmDialog from "dialogs/ConfirmDialog";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';


const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  modal: {
    position:'absolute',
    width: 800,
    backgroundColor: 'white',
    borderRadius: 5,
    borderColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2,4,2),
    //padding: "30px 80px 60px",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    focus:{
      outline: 'none'
  },outline: 'none'
  },
}));

const Form = () => {
  const classes = useStyles();
  const [listPracticas, setListPracticas] = useState([]);
  const [listPracticasOriginal, setListPracticasOriginal] = useState([]);
  const [cedulaIdentidad, setCedulaIdentidad] = useState("");
  const params = useParams();
  const methods = useForm({});
  const { handleSubmi, setValue } = methods;
  const [isReadOnly, setIsReadOnly] = useState(false);
  const { hasRole, hasAnyRole } = useAuth();
  let { state } = useLocation();
  const [bandera, setBandera] = useState("");
  const [practicaResponseData, setPracticaResponseData] = useState({});
  const [practicaDetalleResponseData, setPracticaDetalleResponseData] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [sent, setSent] = useState(false);
  const [observacion, setRechazoObservacion] = useState();
  const [modal, setModal]=useState(false);
  const [openGuardar, setOpenGuardar]=useState(false);

  // PRUEBA
  const [detalleResponseData, setDetalleResponseData] = useState({});

  
  const abrirCerrarModal =()=>{
    setModal(!modal);
  }
    const cerrarModal =()=>{  
    setModal(!modal);
    //confirmOne();   
  }
  const handleObservacionChange = ( value) => {
    //rechazoObservacion=value;
    setRechazoObservacion(value);
  };

  useEffect(() => {
    const load = () => {
      try {
        if (state?.edit || state?.readOnly) {
          setIsReadOnly(state.readOnly);
          getServerData();
        } 
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);
  
  const confirmOne = () => {
    handleCloseDialog();
    abrirCerrarModal();
    setSent(false);
    setOpenGuardar(true);
    confirmOnePost();
  }
  const confirmOnePost = async () => {

    try {
      if (observacion == "") {
        Alert.show({
          message : "Por favor ingrese una observación",
          type : "error"
        });
        return;
      }
      
      await trackPromise(DnerhsApi.post(
        `/convenios/practicas/${practicaResponseData.id}/finalizar-cronograma?observacion=${observacion}`
      ));
      setSent(true);
      Alert.show({
        message: "El Cronograma de Practicas ha Finalizado exitosamente.",
        type: "success",
      });

     
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       } 
    }
    history.goBack()
  };

//  <Box sx={classes.box}>
const bodyModal= (
    
  <div className={classes.modal} align="center" classes={{focused: classes.outlinedInputFocused}}>
    <Paper>
      <Card>
      <CardContent>
        <div>
        <br/>
        <Typography align="center" variant="h5" color="primary">
        Observaciones Finalizar Cronograma xxxx
            </Typography>
    
             <br/>

        </div>
        <br/> <br/>
        <Grid item className={classes.field}>
        <TextareaAutosize aria-label="Observacion"  rows={6} rowsMax={10}  placeholder="Observaciones" onChange={(e) =>
                                handleObservacionChange(e.target.value)}
                                style={{width: 600, fontSize: 0.875+'rem', fontFamily: 'Roboto', fontWeight: 400,
                                lineHeight: 1.43,
                                letterSpacing: 0.01071+'em', borderRadius: 10+'px'}}
                                />
        </Grid>
        <br/> <br/>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
      
         
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="default"
              onClick={()=>cerrarModal()}>Cancelar
            </Button>
          </Grid>
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => confirmOne()}
              disabled={openGuardar} 
              >
             
              Guardar
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    </Paper>
  </div>
  
)
  const getServerData = async () => {
    try {
      try {
        let { convenioPracticaId } = params;
        console.log(convenioPracticaId);
        const { data: practicaResponseData } = await DnerhsApi.get(
          `/convenios/practicas/${convenioPracticaId}`
        );
        
        setPracticaResponseData(practicaResponseData);
        
        console.log('practicaResponseData', practicaResponseData)
        
        const { data: practicaDetalleResponseData } = await trackPromise(DnerhsApi.get(
          `/practicas-detalles/${convenioPracticaId}/practicas-detalles`
        ));

        console.log('practicaDetalleResponseData', practicaDetalleResponseData);
        
        setPracticaDetalleResponseData(practicaDetalleResponseData);

        practicaResponseData.practicaDetalleList=practicaDetalleResponseData;

         const formValues = {
          carrera: practicaResponseData.convenioCarrera?.carreraPrograma?.descripcion==="Postgrado"? "Postgrado - " + practicaResponseData.convenioCarrera?.nombrePostgrado?.descripcion : practicaResponseData.convenioCarrera?.carreraPrograma?.descripcion,
          materia: practicaResponseData.materia,
          curso: practicaResponseData.curso,
          semestre: practicaResponseData.semestre,
          observacion: practicaResponseData.observacion,
        };
  
        Object.keys(formValues).forEach((field) => {
          setValue(field, formValues[field]);
        });
        /*practicaResponseData.practicaDetalleList.forEach( async (k) => {
          const { data: practicaDetalleHorarioIdResponseData } = await trackPromise(DnerhsApi.get(
            `/practicas-detalles-horarios/${k.id}/horarios`
          ));
          
          k.practicaDetalleHorarioList=practicaDetalleHorarioIdResponseData;
          if(k.practicaDetalleHorarioList){
            k.practicaDetalleHorarioList.forEach((ho)=>{
              console.log(ho);
              if(ho.dia=="1"){ 
                k.lunes=true;
              }
              if(ho.dia=="2"){ 
                k.martes=true;
              }
              if(ho.dia=="3"){ 
                k.miercoles=true;
              }
              if(ho.dia=="4"){ 
                k.jueves=true;
              }
              if(ho.dia=="5"){ 
                k.viernes=true;
              }
              if(ho.dia=="6"){ 
                k.sabado=true;
              }
              if(ho.dia=="7"){ 
                k.domingo=true;
              }
            });
            
          }*/
          /*contadorHorarios++;
          if( practicaResponseData.practicaDetalleList.length===contadorHorarios){
            setListPracticas(practicaResponseData.practicaDetalleList);
            let carreraAux=getValues("carrera");
            let [responseCarreras] = await Promise.all([ getCarrerasProgramas(params.convenioId)] )
            responseCarreras.data.forEach((el)=>{
              if(el.id===carreraAux){
                setCarrAux(el.carreraPrograma.id);
              }
            });
          }*/
        //});*/
        /*let { practicaDetalleList } = practicaResponseData;
        
        setListPracticas(practicaDetalleList);
        setListPracticasOriginal(practicaDetalleList);*/
        let contadorHorarios=0;
      practicaResponseData.practicaDetalleList.forEach( async (k) => {
        const { data: practicaDetalleHorarioIdResponseData } = await trackPromise(DnerhsApi.get(
          `/practicas-detalles-horarios/${k.id}/horarios`
        ));
        
        k.practicaDetalleHorarioList=practicaDetalleHorarioIdResponseData;
        if(k.practicaDetalleHorarioList){
          k.practicaDetalleHorarioList.forEach((ho)=>{
            console.log(ho);
            if(ho.dia=="1"){ 
              k.lunes=true;
            }
            if(ho.dia=="2"){ 
              k.martes=true;
            }
            if(ho.dia=="3"){ 
              k.miercoles=true;
            }
            if(ho.dia=="4"){ 
              k.jueves=true;
            }
            if(ho.dia=="5"){ 
              k.viernes=true;
            }
            if(ho.dia=="6"){ 
              k.sabado=true;
            }
            if(ho.dia=="7"){ 
              k.domingo=true;
            }
            k.horarioDesde = ho.horarioDesde
            k.horarioHasta = ho.horarioHasta
          });
          
        }
        contadorHorarios++;
        if( practicaResponseData.practicaDetalleList.length===contadorHorarios){
          setListPracticas(practicaResponseData.practicaDetalleList);
          setListPracticasOriginal(practicaResponseData.practicaDetalleList);
          //let carreraAux=getValues("carrera");
          /*let [responseCarreras] = await Promise.all([ getCarrerasProgramas(params.convenioId)] )
          responseCarreras.data.forEach((el)=>{
            if(el.id===carreraAux){
              setCarrAux(el.carreraPrograma.id);
            }
          });*/
        }
      });
      } catch (error) {
        console.log(error);
        if (error.response) {
          showServerError(error);
        } else {
          showMessageError(error);
        }
      }

    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  };

  const handleSearchEstudiante = () => {
    if (cedulaIdentidad) {
      let listPracticaFilter = listPracticasOriginal.filter(
        item => item.convenioEstudiante.estudiante.cedulaIdentidad == cedulaIdentidad
      );
      setListPracticas(listPracticaFilter);
    }else {
      setListPracticas(listPracticasOriginal);
    }
  }

  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error",
    });
  };

  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error",
    });
  };

  // Handler para Confirmación Institución Formadora
  const handleChangeConfirmacionInstitucion = async (event, row) => {
    try {
      console.log('Confirmación Institución Formadora - Row: ', row.id);

      const result = await trackPromise(
        DnerhsApi.post(`/convenios/practicas/confirmacion/${row.id}?confirmacion=${event.target.checked}`)
      );

      console.log('result', result);

      if (result.status === 200) {
        Alert.show({
          message: event.target.checked
            ? "Práctica confirmada por Institución Formadora exitosamente."
            : "Confirmación de Institución Formadora removida exitosamente.",
          type: "success",
        });

        // Recargar datos para actualizar la vista
        getServerData();
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      } else {
        Alert.show({
          message: "Ocurrió un error al confirmar la práctica",
          type: "error",
        });
      }
    }
  };

  // Handler para Confirmación Establecimiento
  const handleChangeConfirmacionEstablecimiento = async (event, row) => {
    try {
        console.log('Confirmación Establecimiento - Row: ', row.id);

        // Confirmar / Desconfirmar práctica-detalle
        const result = await trackPromise(
            DnerhsApi.post(`/convenios/practicas/confirmacion-establecimiento/${row.id}?confirmacion=${event.target.checked}`)
        );

        console.log('result', result);

        if (result.status === 200) {
             // Continuar con otras acciones...
            // let url_constancia = `/practicas-detalles/${row.id}/constancia_id`;

            //             // let url_constancia = `/constancias/buscar-constancia/${row.id}`;

            //             // const responseConstanciaId = await trackPromise(DnerhsApi.get(url_constancia));

            //             // console.log('responseConstanciaId', responseConstanciaId);

            // // Obtener datos de constancia
            // let data_constancia = await DnerhsApi.get(`/constancias/${responseConstanciaId.data}`);
            // let data_send = data_constancia.data;

            // let url = "/constancias";
            // let { data } = await trackPromise(DnerhsApi.put(url, {
            //     ...data_send,
            //     confirmacionEstablecimiento: !row.confirmacion_establecimiento
            // }));
            Alert.show({
                message: result.data || "Práctica confirmada exitosamente.",
                type: "success",
            });
        } else {
            // Error al confirmar
            Alert.show({
                message: result.data || "Error al confirmar la práctica.",
                type: "error",
            });
        }

       

        trackPromise(getServerData());
    } catch (error) {
        console.log(error);
        if (error.response) {
            showServerError(error);
        } else {
            showMessageError(error);
        }
    }
}


  const checkDayFormat = (day) => {
    return day ? (
      <CheckIcon color="secondary" />
    ) : (
      <CloseIcon color="primary" />
    );
  }

  const handleNumeroDocumentoKeyPress = (event) => {
    if(event.key === 'Enter'){
     handleSearchEstudiante();
    }
  }

  const handleResetSearch = () => {
    setCedulaIdentidad("");
    setListPracticas(listPracticasOriginal);
  }

  const formatDate = (value) => {
    if (!value) {
      return "";
    }
    const datePart = String(value).split("T")[0];
    const [year, month, day] = datePart.split("-");
    if (!year || !month || !day) {
      return String(value);
    }
    return `${day}/${month}/${year}`;
  };

  const formatBooleanExcel = (value) => value === true ? "✓" : "X";

  const getAlumnoNombre = (row) => [
    row.convenioEstudiante?.estudiante?.nombres,
    row.convenioEstudiante?.estudiante?.apellidos,
  ].filter(Boolean).join(" ");

  const getTutorNombre = (row) => [
    row.convenioTutor?.tutor?.nombres,
    row.convenioTutor?.tutor?.apellidos,
  ].filter(Boolean).join(" ");

  const exportarCronogramaExcel = () => {
    const rows = listPracticasOriginal.length ? listPracticasOriginal : listPracticas;
    if (!rows.length) {
      Alert.show({
        message: "No hay alumnos cargados para exportar.",
        type: "error",
      });
      return;
    }

    const carrera = practicaResponseData.convenioCarrera?.carreraPrograma?.descripcion === "Postgrado"
      ? `Postgrado - ${practicaResponseData.convenioCarrera?.nombrePostgrado?.descripcion || ""}`
      : practicaResponseData.convenioCarrera?.carreraPrograma?.descripcion;
    const periodo = [
      formatDate(practicaResponseData.fechaDesde),
      formatDate(practicaResponseData.fechaHasta),
    ].filter(Boolean).join(" - ");

    const worksheetData = [
      ["CRONOGRAMA DE PRACTICAS"],
      [],
      ["Nro. Cronograma", practicaResponseData.id || params.convenioPracticaId || ""],
      ["Estado", practicaResponseData.estado || ""],
      ["Carrera", carrera || ""],
      ["Materia", practicaResponseData.materia || ""],
      ["Curso", practicaResponseData.curso || ""],
      ["Semestre", practicaResponseData.semestre || ""],
      ["Periodo", periodo],
      ["Total alumnos", rows.length],
      ["Generado", formatDate(new Date().toISOString())],
      [],
      [
        "Confirmacion Institucion Formadora",
        "Confirmacion Establecimiento",
        "Establecimiento",
        "C.I.",
        "Anio",
        "Alumno",
        "Nacionalidad",
        "Sede",
        "Domingo",
        "Lunes",
        "Martes",
        "Miercoles",
        "Jueves",
        "Viernes",
        "Sabado",
        "Horario Desde/Hasta",
        "Total Horas",
        "C.I. Tutor",
        "Tutor",
        "Horario Tutor",
      ],
      ...rows.map((row) => [
        formatBooleanExcel(row.confirmacion),
        formatBooleanExcel(row.confirmacionEstablecimiento),
        row.establecimiento?.nombreServicio?.nombre || "",
        row.convenioEstudiante?.estudiante?.cedulaIdentidad || "",
        row.anio || "",
        getAlumnoNombre(row),
        row.convenioEstudiante?.estudiante?.nacionalidad?.nombre || "",
        row.convenioEstudiante?.convenio?.institucionFormadora?.sede || "",
        formatBooleanExcel(row.domingo),
        formatBooleanExcel(row.lunes),
        formatBooleanExcel(row.martes),
        formatBooleanExcel(row.miercoles),
        formatBooleanExcel(row.jueves),
        formatBooleanExcel(row.viernes),
        formatBooleanExcel(row.sabado),
        `${row.horarioDesde || ""} - ${row.horarioHasta || ""}`,
        row.totalHoras ? `${row.totalHoras} hs` : "",
        row.convenioTutor?.tutor?.cedulaIdentidad || "",
        getTutorNombre(row),
        `${row.horarioDesde || ""} - ${row.horarioHasta || ""}`,
      ]),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    worksheet["!cols"] = [
      { wch: 28 }, { wch: 28 }, { wch: 34 }, { wch: 14 }, { wch: 8 },
      { wch: 32 }, { wch: 18 }, { wch: 22 }, { wch: 10 }, { wch: 10 },
      { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
      { wch: 22 }, { wch: 12 }, { wch: 14 }, { wch: 28 }, { wch: 22 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Cronograma");
    XLSX.writeFile(workbook, `Cronograma_${practicaResponseData.id || params.convenioPracticaId}_${new Date().toISOString().split("T")[0]}.xlsx`);

    Alert.show({
      message: "Cronograma exportado a Excel exitosamente.",
      type: "success",
    });
  };

  const handleChangeCedulaIdentidad = (event) => {
    setCedulaIdentidad(event.target.value)
  }
  const showButtonFinalizar = practicaResponseData.id &&
  (
    practicaResponseData.estado === EstadosCronograma.PRACTICA_APROBADA ||
    practicaResponseData.estado === EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA);
  const isCronogramaFinalizado =
    practicaResponseData.estado === EstadosCronograma.PRACTICA_CRONOGRAMA_FINALIZADA;
  const isCronogramaConfirmable =
    practicaResponseData.estado === EstadosCronograma.PRACTICA_APROBADA ||
    practicaResponseData.estado === EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA ||
    isCronogramaFinalizado;
  const pendientesInstitucion = listPracticas.filter((row) => row.confirmacion !== true).length;
  const pendientesEstablecimiento = listPracticas.filter((row) => row.confirmacionEstablecimiento !== true).length;
  const mensajeEstadoConfirmaciones = () => {
    if (!listPracticas.length) {
      return "";
    }
    const total = listPracticas.length;
    return `Confirmaciones de asistencia: Institucion Formadora ${total - pendientesInstitucion}/${total}, Servicio/Establecimiento ${total - pendientesEstablecimiento}/${total}. Los pendientes pueden corresponder a alumnos que no asistieron.`;
  };
  const puedeEditarConfirmacionInstitucion = (row) => {
    if (!hasAnyRole([Roles.ROLE_USER, Roles.ROLE_ADMIN, Roles.ROLE_DNERHS])) {
      return false;
    }
    if (!isCronogramaConfirmable) {
      return false;
    }
    return true;
  };
  const puedeEditarConfirmacionEstablecimiento = (row) => {
    if (!hasAnyRole([Roles.ROLE_RESPONSABLE_ESTABLECIMIENTO, Roles.ROLE_ADMIN, Roles.ROLE_DNERHS])) {
      return false;
    }
    if (!isCronogramaConfirmable) {
      return false;
    }
    return true;
  };
  const tooltipConfirmacionInstitucion = (row) => {
    if (!hasAnyRole([Roles.ROLE_USER, Roles.ROLE_ADMIN, Roles.ROLE_DNERHS])) {
      return "Confirmacion de Institucion Formadora";
    }
    if (isCronogramaFinalizado) {
      return "Confirmar o desconfirmar asistencia del alumno.";
    }
    return "Confirmar Institucion Formadora";
  };
  const tooltipConfirmacionEstablecimiento = (row) => {
    if (!hasAnyRole([Roles.ROLE_RESPONSABLE_ESTABLECIMIENTO, Roles.ROLE_ADMIN, Roles.ROLE_DNERHS])) {
      return "Confirmacion de Servicio/Establecimiento";
    }
    if (isCronogramaFinalizado) {
      return "Confirmar o desconfirmar asistencia del alumno.";
    }
    return "Confirmar Servicio/Establecimiento";
  };
  /*MODAL*/
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };



  return (
    <>
      <Paper>
        <Box padding={5}>
          <Grid item xs={12}>
            <Typography align="center" variant="h5" color="primary">
              Confirmación de Prácticas
            </Typography>
            <Typography align="center" variant="subtitle1" color="textSecondary">
              Nro. Cronograma / ID Practica: <strong>{practicaResponseData.id || params.convenioPracticaId}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormProvider {...methods}>
              <form>
                <Grid container direction="row">
                  <Grid item xs={6}>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        name="carrera"
                        label="Carrera"
                        disabled={isReadOnly}
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        name="materia"
                        label="Materia"
                        disabled={isReadOnly}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        type="number"
                        name="curso"
                        label="Curso"
                        disabled={isReadOnly}
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        type="number"
                        name="semestre"
                        label="Semestre"
                        disabled={isReadOnly} 
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </FormProvider>
          </Grid>
          <Grid item xs={12}>
            <Typography align="center" variant="h6" color="primary">
              Estudiantes
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            className={classes.field}
          >
            <TextField
              fullWidth
              value={cedulaIdentidad}
              defaulValue=""
              onChange={handleChangeCedulaIdentidad}
              onKeyPress={handleNumeroDocumentoKeyPress}
              label="Cédula de identidad"
              InputProps={{
                endAdornment: (
                  <>
                  <InputAdornment position="end" onClick={handleResetSearch}>
                  <IconButton>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
                  <InputAdornment position="end" onClick={handleSearchEstudiante}>
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                  </>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<GetAppIcon />}
              onClick={exportarCronogramaExcel}
              disabled={!listPracticas.length}
            >
              Descargar Excel
            </Button>
          </Grid>
          {listPracticas.length > 0 && (
            <Grid item xs={12} className={classes.field}>
              <Typography
                variant="body2"
                color={pendientesInstitucion === 0 && pendientesEstablecimiento === 0 ? "primary" : "error"}
              >
                {mensajeEstadoConfirmaciones()}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid item xs={12}>
              <TableContainer>
                <Table aria-label="Datos estadisticos">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Confirmacion Institucion Formadora</TableCell>
                      <TableCell align="left">Confirmacion Establecimiento</TableCell>
                      <TableCell align="left">Establecimiento</TableCell>
                      <TableCell align="left">C.I.</TableCell>
                      <TableCell align="left">Año</TableCell>
                      <TableCell align="left">Alumno</TableCell>
                      <TableCell align="left">Nacionalidad</TableCell>
                      <TableCell align="left">Sede</TableCell>                   
                      <TableCell align="left">D</TableCell>
                      <TableCell align="left">L</TableCell>
                      <TableCell align="left">M</TableCell>
                      <TableCell align="left">X</TableCell>
                      <TableCell align="left">J</TableCell>
                      <TableCell align="left">V</TableCell>
                      <TableCell align="left">S</TableCell>
                      <TableCell align="left">Horario Desde/Hasta</TableCell>
                      <TableCell align="left">Total Horas</TableCell>
                      <TableCell align="left">C.I. Tutor</TableCell>

                      <TableCell align="left">Tutor</TableCell>
                      <TableCell align="left">Horario del Tutor</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                      {listPracticas.length > 0 ? (
                        listPracticas.map((row, index) => {
                          // Aquí dentro es seguro usar console.log porque es una función
                         // console.log('&&&&&&&&&&&&&&&&&&&&&&& '+ row.confirmacion_establecimiento);

                          return (
                            <TableRow key={index}>
                              <TableCell align="left">
                                <Tooltip title={tooltipConfirmacionInstitucion(row)} aria-label="confirmar">
                                  <Checkbox
                                    checked={Boolean(row.confirmacion)}
                                    onChange={(event) => handleChangeConfirmacionInstitucion(event, row)}
                                    inputProps={{ "aria-label": "primary checkbox" }}
                                    disabled={!puedeEditarConfirmacionInstitucion(row)}
                                  />
                                </Tooltip>
                              </TableCell>
                              <TableCell align="left">
                                <Tooltip title={tooltipConfirmacionEstablecimiento(row)} aria-label="confirmarEstablecimiento">
                                  <Checkbox
                                    checked={Boolean(row.confirmacionEstablecimiento)}
                                    onChange={(event) => handleChangeConfirmacionEstablecimiento(event, row)}
                                    inputProps={{ "aria-label": "primary checkbox" }}
                                    disabled={!puedeEditarConfirmacionEstablecimiento(row)}
                                  />
                                </Tooltip>
                              </TableCell>
                              <TableCell align="left">
                                {row.establecimiento?.nombreServicio.nombre}
                              </TableCell>
                              <TableCell align="left">
                                {row.convenioEstudiante?.estudiante.cedulaIdentidad}
                              </TableCell>
                              <TableCell align="left">{row.anio}</TableCell>
                              <TableCell align="left">
                                {row.convenioEstudiante?.estudiante.nombres}&nbsp;
                                {row.convenioEstudiante?.estudiante.apellidos}
                              </TableCell>
                              <TableCell align="left">
                                {row.convenioEstudiante?.estudiante.nacionalidad.nombre}
                              </TableCell>
                              <TableCell align="left">
                                {row.convenioEstudiante?.convenio.institucionFormadora.sede}
                              </TableCell>
                              <TableCell align="left">{checkDayFormat(row.domingo)}</TableCell>
                              <TableCell align="left">{checkDayFormat(row.lunes)}</TableCell>
                              <TableCell align="left">{checkDayFormat(row.martes)}</TableCell>
                              <TableCell align="left">{checkDayFormat(row.miercoles)}</TableCell>
                              <TableCell align="left">{checkDayFormat(row.jueves)}</TableCell>
                              <TableCell align="left">{checkDayFormat(row.viernes)}</TableCell>
                              <TableCell align="left">{checkDayFormat(row.sabado)}</TableCell>

                              <TableCell align="left">
                                {row.horarioDesde + " - " + row.horarioHasta}
                              </TableCell>

                              <TableCell align="left">{row.totalHoras + " hs"}</TableCell>
                              <TableCell align="left">
                                {row.convenioTutor?.tutor?.cedulaIdentidad}
                              </TableCell>
                              <TableCell align="left">
                                {row.convenioTutor?.tutor?.nombres}&nbsp;
                                {row.convenioTutor?.tutor?.apellidos}
                              </TableCell>
                              <TableCell align="left">
                                {row.horarioDesde + " - " + row.horarioHasta}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            No hay datos disponibles
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

         


          <Grid item xs={12}>
            <Box paddingTop={3}>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item className={classes.field}>
                  <Button
                    variant="contained"
                    color="default"
                    onClick={() => history.goBack()}
                  >
                    Atrás
                  </Button>
                </Grid>
                {hasRole(Roles.ROLE_USER) && (
                  <>
                  

                    {showButtonFinalizar && (
                      <Grid item className={classes.field}>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => abrirCerrarModal()}
                        >
                          Finalizar Cronograma
                        </Button>
                      </Grid>
                    )}
                   
                  </>
                )}
              </Grid>
            </Box>
          </Grid>
        </Box>
        <ConfirmDialog
            open={openDialog}            
            onAccept={confirmOne}
            onSave={confirmOne}
            onClose={handleCloseDialog}
            aria-labelledby="form-dialog-title"
          />
      </Paper>
      <Modal backdrop="static"
        open={modal} variant="standard"
        InputProps={{
                disableUnderline: true,
              }}
              style={{outline: 'none'}}
              classes={{focused: classes.outlinedInputFocused}}
      >
      
        {bodyModal}
      </Modal>
    </>
  );
};

export default Form;

